<!-- @format -->
<template>
    <article class="mt-2">
        <div class="content">
            <h1>Contact Us</h1>

            <p>
                We're just a phone call or email away! We love technology but we're kind of into that "being human"
                thing when it comes to communication. Please drop us a line.
            </p>

            <p class="mb-0">122 Canal Street / P.O. Box 669</p>
            <p class="mb-0">Ellenville, NY 12428</p>
            <p class="mb-0">(845) 647-9190</p>
            <p class="mb-0">
                <a class="mr-2" href="mailto:info@gunkjournal.com">info@gunkjournal.com</a>
            </p>
            <social-media-icons-group></social-media-icons-group>
        </div>

        <div class="content">
            <p>Please use the form below to send us an email.</p>
        </div>

        <contact-name :form-data.sync="formDataName" :errors="inputErrors" />

        <contact-email :form-data.sync="formDataEmail" :errors="inputErrors" />

        <contact-phone :form-data.sync="formDataPhone" :errors="inputErrors" />

        <contact-interest :form-data.sync="formDataInterest" :errors="inputErrors" />

        <contact-comment :form-data.sync="formDataComment" :errors="inputErrors" />

        <div class="buttons">
            <button type="button" class="button is-success" :class="{ 'is-loading': isBusy }" @click="doSend">
                <span class="icon is-small"><fa-icon icon="check" /></span><span>Send</span>
            </button>
            <button type="button" v-if="!noHeader" class="button is-danger" @click="doCancel">
                <span class="icon is-small"><fa-icon icon="times" /></span><span>Cancel</span>
            </button>
        </div>
    </article>
</template>

<script>
import { mapGetters } from 'vuex';
import { mediaMixin } from '@/mixins/MediaMixin.js';
import ContactComment from '../../Shared/Comment.vue';
import ContactEmail from '../../Shared/Email.vue';
import ContactInterest from '../../Shared/Interest.vue';
import ContactName from '../../Shared/Name.vue';
import ContactPhone from '../../Shared/Phone.vue';
import { createContactUs } from '@/services/corporate';
import SocialMediaIconsGroup from '@/components/Content/Social-Media/Icons/Group.vue';

export default {
    components: {
        ContactComment,
        ContactEmail,
        ContactInterest,
        ContactName,
        ContactPhone,
        SocialMediaIconsGroup
    },
    mixins: [mediaMixin],
    props: {
        noHeader: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isBusy: false,
            errors: [],
            inputErrors: [],
            formDataName: {},
            formDataEmail: {},
            formDataPhone: {},
            formDataInterest: {},
            formDataComment: {}
        };
    },
    computed: {
        ...mapGetters({
            mainPublicationId: 'publication/mainPublicationId'
        })
    },
    mounted() {
        this.clientScrollTop();
    },
    methods: {
        /**
         * Clear form fields
         */
        clearForm() {
            this.formDataName = {
                name: null
            };
            this.formDataEmail = {
                email: null
            };
            this.formDataPhone = {
                phone: null
            };
            this.formDataInterest = {
                interest: []
            };
            this.formDataComment = {
                comment: null
            };
        },
        /**
         * Send form
         */
        async doSend() {
            const data = {
                publication_id: this.mainPublicationId,
                name: this.formDataName.name,
                email: this.formDataEmail.email,
                phone: this.formDataPhone.phone,
                interest: this.formDataInterest.interest.join(','), // Pretty simple form - just combining into one field - NOT a separate table for each interest
                comment: this.formDataComment.comment
            };
            this.errors = [];
            this.inputErrors = [];
            this.isBusy = true;
            try {
                const response = await createContactUs(data);
                this.isBusy = false;
                if (!response.success) {
                    this.errors = response.errors ? response.errors : null;
                    this.inputErrors = response.inputErrors ? response.inputErrors : null;
                } else {
                    this.clearForm();
                    this.$swal({
                        type: 'success',
                        title: 'Thank you!',
                        text: '', //We will review your request and get back to you soon.',
                        showCancelButton: false
                    });
                    this.$emit('cancel');
                }
            } catch (error) {
                this.isBusy = false;
                this.inputErrors = error?.error?.response.data.errors || [error.message];
            }
        },
        /**
         * Cancel
         */
        doCancel() {
            this.$emit('cancel');
        }
    }
};
</script>
